export default __webpack_public_path__ + "static/media/freezette-burger.72a55cb4.jpg";